
export default function routes($stateProvider) {
	$stateProvider
		.state('marketersPage', {
			url: '/marketers',
			template: require('./marketers.html'),
			resolve: {
				loggedIn: ['User', function (User) {
					return User.requireLogin();
				}],
				marketers: ['Marketer', function (Marketer) {
					return Marketer.all();
				}]
			},
			controller: 'MarketersController',
			controllerAs: 'marketers'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/marketers/marketers.routes.js